import * as React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation.ts';
import type {EmptyStateProps} from '@spaced-out/ui-design-system/lib/components/EmptyState';

import {BrandButton} from '../../lib/brand-button/brand-button';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa';


interface IErrorStateProps {
  imageVariant: EmptyStateProps['imageVariant'];
  title: string;
  allowRetry?: boolean;
  description?: string;
  onRetry: () => void;
  testId?: string;
}

export const ErrorState = ({
  imageVariant = 'calendar',
  title,
  allowRetry = false,
  description,
  onRetry,
  testId,
}: IErrorStateProps) => {
  const {t} = useLabelTranslation();

  const errorDescription =
    description ||
    t(
      'Something_went_wrong_Please_try_again',
      'Something went wrong. Please try again',
    );

  return (
    <EmptyState
      imageVariant={imageVariant}
      // already translated in errorMessage
      // eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels
      title={title}
      testId={generateTestId({base: testId, slot: 'empty-state'})}
      {...(allowRetry && {
        description: errorDescription,
      })}
    >
      {allowRetry && (
        <BrandButton
          onClick={onRetry}
          size="small"
          testId={generateTestId({base: testId, slot: 'retry-button'})}
        >
          {t('Retry', 'Retry')}
        </BrandButton>
      )}
    </EmptyState>
  );
};
